"use client";
import { Box, Typography, Container, Divider, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <Container
      sx={{
        py: 5,
        maxWidth: "md",
      }}
    >
      <Typography variant="h4" fontWeight="bold" mb={2} textAlign="center">
        Privacy Policy
      </Typography>

      <Divider sx={{ mb: 3 }} />

      <Box sx={{ fontSize: "1rem", lineHeight: 1.8, color: "text.secondary" }}>
        <Typography paragraph>
          At <b>Kalyani Matrimony</b>, your privacy and trust are extremely
          important to us. This policy explains how we collect, use, protect,
          and share your information when you use our platform.
        </Typography>

        <Typography variant="h6" mt={3}>
          1. Information We Collect
        </Typography>
        <Typography paragraph>
          We collect information that you voluntarily provide, including your
          name, email, contact number, gender, age, religion, and location. We
          may also collect limited technical data such as your IP address and
          browser type for security and analytics.
        </Typography>

        <Typography variant="h6" mt={3}>
          2. How We Use Your Information
        </Typography>
        <Typography paragraph>
          The information you provide is used to:
          <ul>
            <li>Match your profile with suitable candidates.</li>
            <li>Enhance your user experience.</li>
            <li>Provide customer support and updates.</li>
            <li>Prevent fraudulent activity and ensure safety.</li>
          </ul>
        </Typography>

        <Typography variant="h6" mt={3}>
          3. Data Sharing
        </Typography>
        <Typography paragraph>
          We do not sell or rent your personal data to third parties. We may
          share your information only with trusted partners or service providers
          assisting in operating our platform — all bound by strict
          confidentiality agreements.
        </Typography>

        <Typography variant="h6" mt={3}>
          4. Security Measures
        </Typography>
        <Typography paragraph>
          We use encryption and secure servers to protect your data. However,
          please understand that no online transmission is 100% secure. Users
          are encouraged to share information cautiously.
        </Typography>

        <Typography variant="h6" mt={3}>
          5. Cookies
        </Typography>
        <Typography paragraph>
          Our website may use cookies to improve functionality and analyze user
          behavior. You can disable cookies in your browser settings, but some
          features may not function properly.
        </Typography>

        <Typography variant="h6" mt={3}>
          6. User Rights
        </Typography>
        <Typography paragraph>
          You can access, modify, or delete your data anytime from your account
          dashboard. You can also contact us to request data removal or to
          withdraw your consent.
        </Typography>

        <Typography variant="h6" mt={3}>
          7. Third-Party Links
        </Typography>
        <Typography paragraph>
          Our platform may contain links to external websites. We are not
          responsible for the privacy practices or content of those sites.
        </Typography>

        <Typography variant="h6" mt={3}>
          8. Policy Updates
        </Typography>
        <Typography paragraph>
          We may update this Privacy Policy occasionally to reflect legal,
          technical, or business changes. We encourage you to review this page
          periodically.
        </Typography>

        <Typography mt={4} fontStyle="italic">
          Last updated: October 2025
        </Typography>
      </Box>

      <Box textAlign="center" mt={4}></Box>
    </Container>
  );
}

export default PrivacyPage;
